
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';
import { register } from './registerServiceWorker';
import './components/tests/TestPrintWatermark.css';
import { initSentry } from './lib/sentry';

initSentry();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

// Add a version update to clear cache issues
localStorage.setItem("app_version", "v8"); // Updating to v8 to clear all caches

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Register service worker after the app is mounted
register();
